import { useTranslation } from "react-i18next";
import { DashboardData } from "services/dashboardService";
import { toPercent } from "utils/format";
import { cn } from "utils/styles";

type Props = {
  variant?: "primary" | "secondary";
  data: DashboardData;
};

export const LeadsCard = ({
  variant = "primary",
  data,
}: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className={cn(
        "rounded-2xl flex flex-1 flex-col",
        variant === "primary"
          ? "bg-primaryMultiply/70 pt-7 pb-5 px-7 min-h-40"
          : "border-white/30 border py-2 px-4 flex flex-col justify-center min-h-28"
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center tablet:justify-start",
          variant === "primary" ? "gap-2.5" : "gap-1"
        )}
      >
        <img
          className={cn(variant === "primary" ? "" : "h-3.5")}
          src="/icons/campaigns/leads.svg"
          alt=""
        />
        <p className={cn(variant === "primary" ? "" : "text-xs")}>
          {t("dashboard.cards.generatedLeads")}
        </p>
      </div>
      <div
        className={cn(
          "flex flex-col items-center tablet:flex-row justify-between font-input",
          variant === "primary" ? "mt-2 desktop:mt-8 gap-4" : "mt-2 gap-3"
        )}
      >
        <div>
          <div
            className={cn(
              "flex justify-center items-end font-bold",
              variant === "primary" ? "gap-2" : "gap-1"
            )}
          >
            <p
              className={cn(
                "text-center",
                variant === "primary"
                  ? "text-xl desktop-lg:text-2xl"
                  : "text-lg"
              )}
            >
              {data.byArea.insideArea.leads}
            </p>
            <p className="text-xs mb-1">
              {toPercent(data.byArea.insideArea.leadsPercentage, i18n.language)}
            </p>
          </div>
          <p className="text-secondary text-xs">
            {t("dashboard.cards.insideArea")}
          </p>
        </div>
        <div>
          <div
            className={cn(
              "flex justify-center items-end font-bold",
              variant === "primary" ? "gap-2" : "gap-1"
            )}
          >
            <p
              className={cn(
                "text-center",
                variant === "primary"
                  ? "text-xl desktop-lg:text-2xl"
                  : "text-lg"
              )}
            >
              {data.byArea.outsideArea.leads}
            </p>
            <p className="text-xs mb-1">
              {toPercent(data.byArea.outsideArea.leadsPercentage, i18n.language)}
            </p>
          </div>
          <p className="text-secondary text-xs">
            {t("dashboard.cards.outsideArea")}
          </p>
        </div>
        <div>
          <div
            className={cn(
              "flex justify-center items-end font-bold",
              variant === "primary" ? "gap-2" : "gap-1"
            )}
          >
            <p
              className={cn(
                "text-center",
                variant === "primary"
                  ? "text-xl desktop-lg:text-2xl"
                  : "text-lg"
              )}
            >
              {data.byArea.pendingGrouped.leads}
            </p>
            <p className="text-xs mb-1">
              {toPercent(data.byArea.pendingGrouped.leadsPercentage, i18n.language)}
            </p>
          </div>
          <p className="text-secondary text-xs">
            {t("dashboard.cards.pending")}
          </p>
        </div>
      </div>
    </div>
  );
};
